{
  "atomicScopes": {
    "AtomicScope": true
  },
  "data": {
    "AppVars": true,
    "Document": true,
    "FlatTheme": true,
    "GlobalImageQuality": true,
    "TextLink": true,
    "Theme": true,
    "CustomMenusCollection": true,
    "Menu": true,
    "PagesGroupCollection": true,
    "PermaLink": true,
    "TPAGlobalData": true
  },
  "style": {
    "WFlatTheme": true,
    "TopLevelStyle": true,
    "GlobalStylesCollection": true
  }
}
